export const isVoid = (x: any) => x === null || x === undefined
